/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/delivery-instructions.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../public/upgrade/core/logger.service';
import * as import10 from '../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/miami-instructions/miami-instructions.component';
import * as import11 from './miami-instructions/miami-instructions.component.ngfactory';
import * as import12 from '@angular/core/src/linker/view_container';
import * as import13 from '../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/cancun-instructions/cancun-instructions.component';
import * as import14 from './cancun-instructions/cancun-instructions.component.ngfactory';
import * as import15 from 'ngx-cookie/src/cookie.service';
import * as import16 from '../../../../../../public/upgrade/root/ga/ga.service';
import * as import17 from '../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/orlando-instructions/orlando-instructions.component';
import * as import18 from './orlando-instructions/orlando-instructions.component.ngfactory';
import * as import19 from '@ngx-translate/core/src/translate.service';
import * as import20 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import21 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import22 from '@angular/core/src/linker/template_ref';
import * as import23 from '@angular/common/src/directives/ng_if';
import * as import24 from '../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/miami-indications-pos/miami-indications-pos.component';
import * as import25 from './miami-indications-pos/miami-indications-pos.component.ngfactory';
import * as import26 from '../../../../../../public/upgrade/root/modal/modal.service';
import * as import27 from '../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/default-instructions/default-instructions.component';
import * as import28 from './default-instructions/default-instructions.component.ngfactory';
import * as import29 from '@ngx-translate/core/src/translate.pipe';
export class Wrapper_DeliveryInstructionsComponent {
  /*private*/ _eventHandler:Function;
  context:import0.DeliveryInstructionsComponent;
  /*private*/ _changed:boolean;
  /*private*/ _changes:{[key: string]:any};
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  /*private*/ _expr_7:any;
  constructor(p0:any) {
    this._changed = false;
    this._changes = {};
    this.context = new import0.DeliveryInstructionsComponent(p0);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
    this._expr_7 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_errors(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.errors = currValue;
      this._changes['errors'] = new import1.SimpleChange(this._expr_0,currValue);
      this._expr_0 = currValue;
    }
  }
  check_errorMessages(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.errorMessages = currValue;
      this._changes['errorMessages'] = new import1.SimpleChange(this._expr_1,currValue);
      this._expr_1 = currValue;
    }
  }
  check_dto(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.dto = currValue;
      this._changes['dto'] = new import1.SimpleChange(this._expr_2,currValue);
      this._expr_2 = currValue;
    }
  }
  check_countryId(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.countryId = currValue;
      this._changes['countryId'] = new import1.SimpleChange(this._expr_3,currValue);
      this._expr_3 = currValue;
    }
  }
  check_hasOtherDeliveryMessage(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.hasOtherDeliveryMessage = currValue;
      this._changes['hasOtherDeliveryMessage'] = new import1.SimpleChange(this._expr_4,currValue);
      this._expr_4 = currValue;
    }
  }
  check_enabledCity(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this._changed = true;
      this.context.enabledCity = currValue;
      this._changes['enabledCity'] = new import1.SimpleChange(this._expr_5,currValue);
      this._expr_5 = currValue;
    }
  }
  check_isPointOfSale(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_6,currValue))) {
      this._changed = true;
      this.context.isPointOfSale = currValue;
      this._changes['isPointOfSale'] = new import1.SimpleChange(this._expr_6,currValue);
      this._expr_6 = currValue;
    }
  }
  check_isValidLocation(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_7,currValue))) {
      this._changed = true;
      this.context.isValidLocation = currValue;
      this._changes['isValidLocation'] = new import1.SimpleChange(this._expr_7,currValue);
      this._expr_7 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) {
      if (changed) {
        this.context.ngOnChanges(this._changes);
        this._changes = {};
      }
      if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); }
    }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_DeliveryInstructionsComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_DeliveryInstructionsComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.DeliveryInstructionsComponent>;
  _DeliveryInstructionsComponent_0_3:Wrapper_DeliveryInstructionsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DeliveryInstructionsComponent_Host0,renderType_DeliveryInstructionsComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'delivery-instructions',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_DeliveryInstructionsComponent0(this.viewUtils,this,0,this._el_0);
    this._DeliveryInstructionsComponent_0_3 = new Wrapper_DeliveryInstructionsComponent(this.injectorGet(import9.LoggerService,this.parentIndex));
    this.compView_0.create(this._DeliveryInstructionsComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._DeliveryInstructionsComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.DeliveryInstructionsComponent) && (0 === requestNodeIndex))) { return this._DeliveryInstructionsComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._DeliveryInstructionsComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const DeliveryInstructionsComponentNgFactory:import8.ComponentFactory<import0.DeliveryInstructionsComponent> = new import8.ComponentFactory<import0.DeliveryInstructionsComponent>('delivery-instructions',View_DeliveryInstructionsComponent_Host0,import0.DeliveryInstructionsComponent);
const styles_DeliveryInstructionsComponent:any[] = ([] as any[]);
class View_DeliveryInstructionsComponent2 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import10.MiamiInstructionsComponent>;
  _MiamiInstructionsComponent_0_3:import11.Wrapper_MiamiInstructionsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_DeliveryInstructionsComponent2,renderType_DeliveryInstructionsComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'miami-instructions',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import11.View_MiamiInstructionsComponent0(this.viewUtils,this,0,this._el_0);
    this._MiamiInstructionsComponent_0_3 = new import11.Wrapper_MiamiInstructionsComponent();
    this.compView_0.create(this._MiamiInstructionsComponent_0_3.context);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_0));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import10.MiamiInstructionsComponent) && (0 === requestNodeIndex))) { return this._MiamiInstructionsComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parentView.parentView.context.errorsToChild;
    this._MiamiInstructionsComponent_0_3.check_errors(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this.parentView.parentView.context.dto;
    this._MiamiInstructionsComponent_0_3.check_dto(currVal_0_0_1,throwOnChange,false);
    const currVal_0_0_2:any = this.parentView.parentView.context.countryId;
    this._MiamiInstructionsComponent_0_3.check_countryId(currVal_0_0_2,throwOnChange,false);
    const currVal_0_0_3:any = this.parentView.parentView.context.isValidLocation;
    this._MiamiInstructionsComponent_0_3.check_isValidLocation(currVal_0_0_3,throwOnChange,false);
    this._MiamiInstructionsComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._MiamiInstructionsComponent_0_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_DeliveryInstructionsComponent3 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import13.CancunInstructionsComponent>;
  _CancunInstructionsComponent_0_3:import14.Wrapper_CancunInstructionsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_DeliveryInstructionsComponent3,renderType_DeliveryInstructionsComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'cancun-instructions',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import14.View_CancunInstructionsComponent0(this.viewUtils,this,0,this._el_0);
    this._CancunInstructionsComponent_0_3 = new import14.Wrapper_CancunInstructionsComponent(this.parentView.parentView.parentView.injectorGet(import15.CookieService,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import16.GAService,this.parentView.parentView.parentIndex));
    this.compView_0.create(this._CancunInstructionsComponent_0_3.context);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_0));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import13.CancunInstructionsComponent) && (0 === requestNodeIndex))) { return this._CancunInstructionsComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parentView.parentView.context.errorsToChild;
    this._CancunInstructionsComponent_0_3.check_errors(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this.parentView.parentView.context.dto;
    this._CancunInstructionsComponent_0_3.check_dto(currVal_0_0_1,throwOnChange,false);
    const currVal_0_0_2:any = this.parentView.parentView.context.countryId;
    this._CancunInstructionsComponent_0_3.check_countryId(currVal_0_0_2,throwOnChange,false);
    const currVal_0_0_3:any = this.parentView.parentView.context.isValidLocation;
    this._CancunInstructionsComponent_0_3.check_isValidLocation(currVal_0_0_3,throwOnChange,false);
    this._CancunInstructionsComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._CancunInstructionsComponent_0_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._CancunInstructionsComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_DeliveryInstructionsComponent4 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import17.OrlandoInstructionsComponent>;
  _OrlandoInstructionsComponent_0_3:import18.Wrapper_OrlandoInstructionsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_DeliveryInstructionsComponent4,renderType_DeliveryInstructionsComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'orlando-instructions',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import18.View_OrlandoInstructionsComponent0(this.viewUtils,this,0,this._el_0);
    this._OrlandoInstructionsComponent_0_3 = new import18.Wrapper_OrlandoInstructionsComponent(this.parentView.parentView.parentView.injectorGet(import19.TranslateService,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import20.NotificationService,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import15.CookieService,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import16.GAService,this.parentView.parentView.parentIndex));
    this.compView_0.create(this._OrlandoInstructionsComponent_0_3.context);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_0));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.OrlandoInstructionsComponent) && (0 === requestNodeIndex))) { return this._OrlandoInstructionsComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parentView.parentView.context.errorsToChild;
    this._OrlandoInstructionsComponent_0_3.check_errors(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this.parentView.parentView.context.dto;
    this._OrlandoInstructionsComponent_0_3.check_dto(currVal_0_0_1,throwOnChange,false);
    const currVal_0_0_2:any = this.parentView.parentView.context.countryId;
    this._OrlandoInstructionsComponent_0_3.check_countryId(currVal_0_0_2,throwOnChange,false);
    const currVal_0_0_3:any = this.parentView.parentView.context.isValidLocation;
    this._OrlandoInstructionsComponent_0_3.check_isValidLocation(currVal_0_0_3,throwOnChange,false);
    this._OrlandoInstructionsComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._OrlandoInstructionsComponent_0_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_DeliveryInstructionsComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import12.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import21.Wrapper_NgIf;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import12.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import21.Wrapper_NgIf;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _vc_6:import12.ViewContainer;
  _TemplateRef_6_5:any;
  _NgIf_6_6:import21.Wrapper_NgIf;
  _text_7:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_DeliveryInstructionsComponent1,renderType_DeliveryInstructionsComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import12.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import22.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import21.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_4 = new import12.ViewContainer(4,0,this,this._anchor_4);
    this._TemplateRef_4_5 = new import22.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import21.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_6 = new import12.ViewContainer(6,0,this,this._anchor_6);
    this._TemplateRef_6_5 = new import22.TemplateRef_(this,6,this._anchor_6);
    this._NgIf_6_6 = new import21.Wrapper_NgIf(this._vc_6.vcRef,this._TemplateRef_6_5);
    this._text_7 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._anchor_4,
      this._text_5,
      this._anchor_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import23.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import22.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import23.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    if (((token === import22.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import23.NgIf) && (6 === requestNodeIndex))) { return this._NgIf_6_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.isMiamiAirport(this.parentView.context.dto.locationOid);
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    const currVal_4_0_0:any = this.parentView.context.isCancunAirport(this.parentView.context.dto.locationOid);
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    const currVal_6_0_0:any = this.parentView.context.isOrlandoAirport(this.parentView.context.dto.locationOid);
    this._NgIf_6_6.check_ngIf(currVal_6_0_0,throwOnChange,false);
    this._NgIf_6_6.ngDoCheck(this,this._anchor_6,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
    this._vc_6.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._vc_4.destroyNestedViews();
    this._vc_6.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 2)) { return new View_DeliveryInstructionsComponent2(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    if ((nodeIndex == 4)) { return new View_DeliveryInstructionsComponent3(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    if ((nodeIndex == 6)) { return new View_DeliveryInstructionsComponent4(this.viewUtils,this,6,this._anchor_6,this._vc_6); }
    return (null as any);
  }
}
class View_DeliveryInstructionsComponent6 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import24.MiamiIndicationsPosComponent>;
  _MiamiIndicationsPosComponent_2_3:import25.Wrapper_MiamiIndicationsPosComponent;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_DeliveryInstructionsComponent6,renderType_DeliveryInstructionsComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'miami-indications-pos',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import25.View_MiamiIndicationsPosComponent0(this.viewUtils,this,2,this._el_2);
    this._MiamiIndicationsPosComponent_2_3 = new import25.Wrapper_MiamiIndicationsPosComponent(this.parentView.parentView.parentView.injectorGet(import26.ModalService,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import9.LoggerService,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import19.TranslateService,this.parentView.parentView.parentIndex));
    this.compView_2.create(this._MiamiIndicationsPosComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import24.MiamiIndicationsPosComponent) && (2 === requestNodeIndex))) { return this._MiamiIndicationsPosComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.parentView.context.dto;
    this._MiamiIndicationsPosComponent_2_3.check_dto(currVal_2_0_0,throwOnChange,false);
    this._MiamiIndicationsPosComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._MiamiIndicationsPosComponent_2_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_2.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_DeliveryInstructionsComponent7 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import27.DefaultInstructionsComponent>;
  _DefaultInstructionsComponent_2_3:import28.Wrapper_DefaultInstructionsComponent;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_DeliveryInstructionsComponent7,renderType_DeliveryInstructionsComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'default-instructions',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import28.View_DefaultInstructionsComponent0(this.viewUtils,this,2,this._el_2);
    this._DefaultInstructionsComponent_2_3 = new import28.Wrapper_DefaultInstructionsComponent(this.parentView.parentView.parentView.injectorGet(import26.ModalService,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import9.LoggerService,this.parentView.parentView.parentIndex),this.parentView.parentView.parentView.injectorGet(import19.TranslateService,this.parentView.parentView.parentIndex));
    this.compView_2.create(this._DefaultInstructionsComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import27.DefaultInstructionsComponent) && (2 === requestNodeIndex))) { return this._DefaultInstructionsComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.parentView.context.dto;
    this._DefaultInstructionsComponent_2_3.check_dto(currVal_2_0_0,throwOnChange,false);
    this._DefaultInstructionsComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._DefaultInstructionsComponent_2_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_2.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_DeliveryInstructionsComponent5 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _anchor_11:any;
  /*private*/ _vc_11:import12.ViewContainer;
  _TemplateRef_11_5:any;
  _NgIf_11_6:import21.Wrapper_NgIf;
  _text_12:any;
  _anchor_13:any;
  /*private*/ _vc_13:import12.ViewContainer;
  _TemplateRef_13_5:any;
  _NgIf_13_6:import21.Wrapper_NgIf;
  _text_14:any;
  /*private*/ _expr_21:any;
  _pipe_translate_0:import29.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_DeliveryInstructionsComponent5,renderType_DeliveryInstructionsComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_21 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 -eva-3-mb-md'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_11 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_11 = new import12.ViewContainer(11,0,this,this._anchor_11);
    this._TemplateRef_11_5 = new import22.TemplateRef_(this,11,this._anchor_11);
    this._NgIf_11_6 = new import21.Wrapper_NgIf(this._vc_11.vcRef,this._TemplateRef_11_5);
    this._text_12 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_13 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_13 = new import12.ViewContainer(13,0,this,this._anchor_13);
    this._TemplateRef_13_5 = new import22.TemplateRef_(this,13,this._anchor_13);
    this._NgIf_13_6 = new import21.Wrapper_NgIf(this._vc_13.vcRef,this._TemplateRef_13_5);
    this._text_14 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._pipe_translate_0 = new import29.TranslatePipe(this.parentView.injectorGet(import19.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._anchor_11,
      this._text_12,
      this._anchor_13,
      this._text_14
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (11 === requestNodeIndex))) { return this._TemplateRef_11_5; }
    if (((token === import23.NgIf) && (11 === requestNodeIndex))) { return this._NgIf_11_6.context; }
    if (((token === import22.TemplateRef) && (13 === requestNodeIndex))) { return this._TemplateRef_13_5; }
    if (((token === import23.NgIf) && (13 === requestNodeIndex))) { return this._NgIf_13_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_11_0_0:any = this.parentView.context.isSpecialAirport(this.parentView.context.dto.locationOid);
    this._NgIf_11_6.check_ngIf(currVal_11_0_0,throwOnChange,false);
    this._NgIf_11_6.ngDoCheck(this,this._anchor_11,throwOnChange);
    const currVal_13_0_0:boolean = !this.parentView.context.isSpecialAirport(this.parentView.context.dto.locationOid);
    this._NgIf_13_6.check_ngIf(currVal_13_0_0,throwOnChange,false);
    this._NgIf_13_6.ngDoCheck(this,this._anchor_13,throwOnChange);
    this._vc_11.detectChangesInNestedViews(throwOnChange);
    this._vc_13.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_21:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pointOfSale.MEETING_TYPE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_21,currVal_21))) {
      this.renderer.setText(this._text_7,currVal_21);
      this._expr_21 = currVal_21;
    }
  }
  destroyInternal():void {
    this._vc_11.destroyNestedViews();
    this._vc_13.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 11)) { return new View_DeliveryInstructionsComponent6(this.viewUtils,this,11,this._anchor_11,this._vc_11); }
    if ((nodeIndex == 13)) { return new View_DeliveryInstructionsComponent7(this.viewUtils,this,13,this._anchor_13,this._vc_13); }
    return (null as any);
  }
}
var renderType_DeliveryInstructionsComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_DeliveryInstructionsComponent,{});
export class View_DeliveryInstructionsComponent0 extends import2.AppView<import0.DeliveryInstructionsComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _vc_4:import12.ViewContainer;
  _TemplateRef_4_5:any;
  _NgIf_4_6:import21.Wrapper_NgIf;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _vc_6:import12.ViewContainer;
  _TemplateRef_6_5:any;
  _NgIf_6_6:import21.Wrapper_NgIf;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_DeliveryInstructionsComponent0,renderType_DeliveryInstructionsComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_4 = new import12.ViewContainer(4,2,this,this._anchor_4);
    this._TemplateRef_4_5 = new import22.TemplateRef_(this,4,this._anchor_4);
    this._NgIf_4_6 = new import21.Wrapper_NgIf(this._vc_4.vcRef,this._TemplateRef_4_5);
    this._text_5 = this.renderer.createText(this._el_2,'\n\n        ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._vc_6 = new import12.ViewContainer(6,2,this,this._anchor_6);
    this._TemplateRef_6_5 = new import22.TemplateRef_(this,6,this._anchor_6);
    this._NgIf_6_6 = new import21.Wrapper_NgIf(this._vc_6.vcRef,this._TemplateRef_6_5);
    this._text_7 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_8 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_9 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._anchor_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._text_8,
      this._text_9
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import22.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import23.NgIf) && (4 === requestNodeIndex))) { return this._NgIf_4_6.context; }
    if (((token === import22.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import23.NgIf) && (6 === requestNodeIndex))) { return this._NgIf_6_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_4_0_0:any = this.context.showIndicationsPhone(this.context.dto.locationOid,this.context.isPointOfSale);
    this._NgIf_4_6.check_ngIf(currVal_4_0_0,throwOnChange,false);
    this._NgIf_4_6.ngDoCheck(this,this._anchor_4,throwOnChange);
    const currVal_6_0_0:any = this.context.showIndicationsCards(this.context.dto.locationOid,this.context.isPointOfSale);
    this._NgIf_6_6.check_ngIf(currVal_6_0_0,throwOnChange,false);
    this._NgIf_6_6.ngDoCheck(this,this._anchor_6,throwOnChange);
    this._vc_4.detectChangesInNestedViews(throwOnChange);
    this._vc_6.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_4.destroyNestedViews();
    this._vc_6.destroyNestedViews();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 4)) { return new View_DeliveryInstructionsComponent1(this.viewUtils,this,4,this._anchor_4,this._vc_4); }
    if ((nodeIndex == 6)) { return new View_DeliveryInstructionsComponent5(this.viewUtils,this,6,this._anchor_6,this._vc_6); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pointOfSale/delivery-instructions/delivery-instructions.component.ngfactory.ts